<template>
  <section class="pdf-guide !mt-16" id="pdf-guide" v-animate-in>
    <div class="container">
      <div class="content">
        <div class="title" v-animate-in>
          <h2 class="h1">A Te igényeid.<br />A mi szakértelmünk.</h2>
        </div>
        <div class="text1" v-animate-in>
          <p>
            Az irodakeresés megkezdése nyomasztónak tűnhet. Hadd egyszerűsítsük
            le az utat szakértelemmel összeállított 9 lépéses útmutatónkkal.
            Készen állsz a gondtalan irodakeresésre?
          </p>
        </div>
        <div class="image" v-animate-in>
          <!-- ResponsiveImage
            :data="{
              sizes: [640, 1280, 1920],
              width: '1920',
              height: '1269',
              src: '/pictures/pexels-christina-morillo-1181438.webp',
              alt: 'Forward Advisory',
            }"
          / -->
          <img
            src="@/assets/24_qr_download_9tipp.png"
            style="max-width: 70vw"
          />
        </div>
        <div class="text2" v-animate-in>
          <p>Írd be az email címed, amire elküldhetjük neked a tippeket!</p>
        </div>
        <div class="control" v-animate-in>
          <section class="form pdfguide">
            <form action="" class="form-container" ref="form">
              <div class="form-row question">
                <div class="form-label">
                  <label for="pdf-email" class="required">Név:</label>
                </div>
                <div class="form-control">
                  <input
                    type="text"
                    v-model="name"
                    name="dname"
                    id="pdf-name"
                    placeholder="Neved"
                  />
                </div>
              </div>
              <div class="form-row">
                <div class="form-label">
                  <label for="pdf-email" class="required">E-mail:</label>
                </div>
                <div class="form-control">
                  <input
                    type="email"
                    v-model="mailaddress"
                    name="demail"
                    id="pdf-email"
                    required="required"
                    placeholder="Az e-mail címed"
                  />
                </div>
                <div class="form-error"></div>
              </div>
              <div class="form-row">
                <div class="form-label">
                  <label>&nbsp;</label>
                </div>
                <div class="form-control">
                  <Button arrow="right" class="black">Kérem a tippeket</Button>
                </div>
              </div>
            </form>
            <!--div class="input-holder">
              <label>
                <strong>Email</strong>
                <input
                  type="text"
                  name="email"
                  placeholder="Your email address"
                />
              </label>

              <Button
                :to="{ path: '/' }"
                arrow="right"
                @click="send()"
                class="black"
                >Send me</Button
              >
            </div-->
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Button from "@/components/inputs/Button.vue";
import { Validate } from "@/validate.js";
import axios from "axios";

export default {
  name: "PdfGuide",
  components: {
    Button
    // ResponsiveImage,
  },
  data() {
    return {
      personal: this.$store.getters.getPersonal,
      mailaddress: "",
      name: "",
      pdfguide: false
    };
  },
  mounted() {
    const messages = this.$store.getters.getMessages;
    Validate(this.$refs.form, {
      submit: e => {
        // console.log(e);
        e.preventDefault();
        this.send();
      },
      messages: messages
    });
  },
  methods: {
    async send() {
      try {
        await axios.post("tipps", {
          email: this.mailaddress
        });
        this.$router.push("/modal/siker");
      } catch (e) {
        this.$router.push("/modal/hiba");
      }
    }
  }
};
</script>

<style lang="scss">
.pdf-guide {
  display: block;
  width: 100%;
  //height: 100vh;
  // color: $white;
  padding: 0 0 64px !important;
  margin-top: -100px !important;
  // padding-top: 100px !important;
  //background: $lightgray;
  .question {
    display: none;
  }
  .form-container {
    flex-direction: column;
    .button {
      width: 100%;
    }
  }
  .container {
    .content {
      padding-right: 30px;
      padding-top: 50px;
      display: flex;
      flex-direction: column;
      .title {
        order: 1;
        padding: 0 16px;
        //margin-bottom: 24px;
      }
      .text1 {
        padding: 0 16px;
        order: 2;
      }
      .text2 {
        padding: 0 16px;
        order: 4;
      }
      .image {
        order: 3;
        /* picture {
          display: block;
          width: 100%;
          height: auto;
          img {
            width: 100%;
            height: auto;
          }
        } */
        display: flex;
        justify-content: center;
        padding: 16px;
      }
      .control {
        margin: 0 16px 24px;
        order: 5;
        form,
        .form {
          padding: 0;
        }
        /* .input-holder {
          align-items: flex-start;
          flex-direction: column;
          label {
            width: 100%;
          }
          .button {
            margin: 20px 0 0;
            width: calc(100% - 40px);
            white-space: nowrap;
          }
        } */
      }
    }
  }
  @media screen and (min-width: $breakpoint) {
    margin: 0 0 10px;
    padding: 0 !important;
    .container {
      .content {
        padding-top: 100px;
        position: relative;
        z-index: 10;
        // margin-top: -240px;
        display: flex;
        //height: Min(100vh, 800px);
        height: 100%;
        height: 600px;
        justify-content: center;
        flex-wrap: wrap;
        flex-direction: column;
        .title {
          order: 2;
          width: 58%;
          box-sizing: border-box;
          padding: 0 0 0 50px;
          margin-bottom: 16px;
        }
        .text1 {
          order: 3;
          width: 58%;
          box-sizing: border-box;
          padding: 0 0 0 50px;
          margin-bottom: 24px;
          p {
            margin: 0 0 16px 0;
          }
        }
        .text2 {
          order: 4;
          width: 58%;
          box-sizing: border-box;
          padding: 0 0 0 50px;
          // margin-bottom: 24px;
          p {
            margin: 0 0 16px 0;
          }
        }
        .control {
          order: 5;
          width: 58%;
          box-sizing: border-box;
          padding: 0 0 0 50px;
          margin: 0;
          form,
          .input-holder {
            align-items: flex-start;
            flex-direction: row;
            .form-label {
              width: auto;
            }
            .button {
              width: auto;
              margin: 0 16px;
              white-space: nowrap;
            }
          }
        }
        .image {
          order: 1;
          width: 42%;
          height: 100%;
          display: flex;
          align-items: center;
          // padding-top: 64px;
          justify-content: center;
          // direction: rtl;
          img {
            width: auto;
            height: 100%;
            max-height: 250px;
          }
          /* .responsive-image {
            img {
              border-radius: 12px;
              height: 100%;
              max-height: 800px;
              width: auto;
              display: block;
            }
          }*/
        }
      }
    }
  }
}
</style>
